import PhotoSizeSelectActualOutlinedIcon from "@mui/icons-material/PhotoSizeSelectActualOutlined";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";
import * as React from "react";

import { Collection } from "../../../../generated/gql/graphql";
import {
  getDirectusAssetsPath,
  useDirectus,
} from "../../../../providers/DirectusProvider";
import ContextMenu from "../context-menu/context-menu";

type Props = {
  classes?: string;
  collection: Collection;
};

export default function CollectionCard(props: Props): React.ReactElement {
  const { classes, collection } = props;

  const { directus } = useDirectus();

  const handleClickCollection = (): void => {
    // setCollectionId(collection.id);
    window.location.href = `/collection/${collection.id}`;
  };

  return (
    <Card
      style={{ borderColor: "#E8E8E8", boxShadow: "none" }}
      className={`rounded-[15px] border-solid border-1 relative w-[calc(33%_-_10px)] cursor-pointer ${classes}`}
    >
      <ContextMenu
        imageId="1"
        collection={collection}
        classes="absolute bg-white rounded-[25px] right-[17px] top-[17px]"
      />
      <div className="relative text-center bg-slate-100">
        <div
          className="relative w-full h-full cursor-pointer inline-block"
          onClick={handleClickCollection}
        >
          {collection.image ? (
            <CardMedia
              className="flex w-full h-150 max-h-[150px] object-contain"
              component="img"
              image={`${getDirectusAssetsPath(directus)}/${collection.image}`}
              alt={collection.name || "collection name"}
            />
          ) : (
            <PhotoSizeSelectActualOutlinedIcon className="text-[150px] m-10 text-slate-400" />
          )}
        </div>
      </div>
      <CardContent
        onClick={handleClickCollection}
        className="p-[20px] leading-[17px] last:pb-[10px]"
      >
        <Typography className="text-[21px] cursor-pointer">
          {collection.name}
        </Typography>
        {/*<Typography className="mb-[30px] text-[13px] text-slate-400">*/}
        {/*    {count} Assets*/}
        {/*</Typography>*/}
        {(collection.dateUpdated || collection.dateCreated) && (
          <Typography className="font-light border-[#4a4a4a] text-[13px] text-slate-400">
            Last edited:{" "}
            {format(
              new Date(collection.dateUpdated || collection.dateCreated || 0),
              "dd-MM-yyyy"
            )}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
